import { computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import GetLabel from 'foundation/js/getLabel'

export default {
    name: 'PersonalDonationStep3',
    setup() {
        const store = useStore()

        onMounted(() => {
            const orderId = new URLSearchParams(document.location.search).get(
                'orderId'
            )
            if (orderId)
                store.dispatch('main/trackPurchaseData', { orderId })
        })

        const linkToInformationHowDonationBenefits = computed(
            () =>
                store.state.fundraising.donation_settings
                    .linkToInformationHowDonationBenefits
        )

        return {
            linkToInformationHowDonationBenefits,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'personalDonation' })
        }
    }
}
